import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { OrcamentoService } from '../../../../../providers/orcamento-service';
import { AlertService } from './../../../../../providers/alert-service';
import { MenuService } from './../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from './../../../../../providers/usuario-service';
import { GestaoPcaService } from './../../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-aquisicaoBens',
    templateUrl: 'aquisicaoBens.html',
    providers: [
        OrcamentoService
    ]
})
export class AquisicaoBensPage extends ModulosController {
    listaDados: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;

    //mudar aqui
    idSecaoPagina: string = "8";

    order: string = 'numEmpenho';
    reverse: boolean = true;
    page: number = 1;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public orcamentoService: OrcamentoService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        //mudar aqui
        this.setModuloId(12);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = !this.reverse;
        }

        this.order = value;
    }

    carregarDados() {
        // mudar aqui
        this.orcamentoService.obterAquisicaoBens().subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    formatarPorcentagem(valor) {
        return valor.toString().replace('.', ',') + "%";
    }

    voltarParaOrcamento() {
        this.menuService.redirecionarPagina(this.orcamentoService.obterIdPaginaOrcamento());
    }

    salvarFlagIncluir() {
        this.loading = true;
        this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
        this.orcamentoService.salvarAquisicaoBens(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {

        let idAnalise = "";
        this.loading = true;
        if (this.listaDados.resultadoAnalise == undefined || !this.listaDados.resultadoAnalise || this.listaDados.resultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.resultadoAnalise == null) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                idAnalise = this.listaDados.idModuloAnalise;
                this.listaDados.resultadoAnalise = this.capitalize(this.listaDados.resultadoAnalise);
                this.orcamentoService.submeterAquisicaoBens(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaOrcamento();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    capitalize(str) {
        let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/orcamento/analista/aquisicaoBens/aquisicaoBens.ts